import React from 'react';
import Loading from './Loading';

const ParametroItemAnalise = ({
  col,
  color,
  value,
  label,
  title,
  name,
  loading
}) => (
  <div className={`${col} text-center`}>
    <h3
      style={{
        fontSize: 15,
        color: 'blue',
        textTransform: 'UPPERCASE',
        marginBottom: '20px'
      }}
    >
      <b>{title}</b>
    </h3>
    {loading ? (
      <Loading />
    ) : (
      <React.Fragment>
        <i
          style={{ fontSize: 37, color: 'blue' }}
          className="fas fa-check-circle"
        />
        <p style={{ fontSize: 16 }} className="pt-2 cinza">
          {label}
        </p>
      </React.Fragment>
    )}
  </div>
);

export default ParametroItemAnalise;
